import { Box, Flex } from '@chakra-ui/react';
import { Reservation } from '@data/models';
import BEIcon from '@molecules/BEIcon';
import Text from '@molecules/Text';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import useFormat from '@business/utils/hooks/useFormat';

const StyledData = styled(Flex)`
  margin-top:32px;
  align-items: center;
  gap: 40px;
  
  & .check-box {
    text-align: center;
    width: 100%;
  }

  & .green-color {
    color:#32C0A0;
  }
`;

const CheckInOut = ({ model }: { model: Reservation }) => {
  const { t } = useTranslation();
  const { date: formatDate } = useFormat();

  return (
    <StyledData gap="40px">
      <Box className="check-box">
        <Text color="neutral" weight="400" type="h4">
          {t('check-in')}
        </Text>
        <Text type="h1" size="4xl" color="primary" weight="600">
          {formatDate(model.checkin, 'MMM D, YYYY')}
        </Text>
        <Text weight="400" type="h4">
          {formatDate(model.checkin, 'dddd')}
        </Text>
      </Box>
      <BEIcon
        name="arrow-right"
        size="lg"
        weight="light"
        className="green-color"
      />
      <Box className="check-box">
        <Text color="neutral" weight="400" type="h4">
          {t('check-out')}
        </Text>
        <Text type="h1" size="4xl" color="primary" weight="600">
          {formatDate(model.checkout, 'MMM D, YYYY')}
        </Text>
        <Text weight="400" type="h4">
          {formatDate(model.checkout, 'dddd')}
        </Text>
      </Box>
    </StyledData>
  );
};

export default CheckInOut;
